import { rm } from 'utils';
import styles from './option.scss';
import cn from 'classnames';

export const LoadingOption = () => (
  <div className={cn(styles.option, styles.loading)}>{rm('common_loading')}...</div>
);
